import { ACCESS_LEVELS, FEATURE_FLAGS } from '@/lib/consts.js'
import { useEppo } from '@/composables/eppo'

export default {
  name: 'booksy-wrapped',
  path: 'booksy-wrapped/:path(.*)?',
  meta: {
    accessLevel: ACCESS_LEVELS.MANAGER,
  },
  beforeEnter: (to, from, next) => {
    const eppo = useEppo()
    if (!eppo.ff(FEATURE_FLAGS.Feature_BooksyWrapped)) {
      return next({ name: 'calendar', params: { businessId: to.params.businessId } })
    }
    next()
  },
  component: () => import('@/views/business/booksy-wrapped.vue'),
}

